import React from 'react';

export const orderCashReplenishmentPembukuanConfig = [
  {
    path: '/replenishment-pembukuan',
    component: React.lazy(() => import('./listing/index')),
  },{
    path: '/replenishment-pembukuan/detail',
    component: React.lazy(() => import('./detail/index')),
  }
];
